module.exports = __webpack_public_path__ + "img/VN.47af663b.png";